<script>
import { HorizontalBar } from 'vue-chartjs'

export default {
  extends: HorizontalBar,
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    },
    showDataLabels: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.renderChart(this.chartdata, this.getOptions())
  },
  watch: {
    chartdata: {
      deep: true,
      handler () {
        this.renderChart(this.chartdata, this.getOptions())
      }
    },
    options: {
      deep: true,
      handler () {
        this.renderChart(this.chartdata, this.getOptions())
      }
    },
    showDataLabels () {
      this.renderChart(this.chartdata, this.getOptions())
    }
  },
  methods: {
    getOptions () {
      const baseOptions = this.options || {}
      const plugins = baseOptions.plugins || {}
      const datalabels = plugins.datalabels || {}

      return {
        ...baseOptions,
        plugins: {
          ...plugins,
          datalabels: {
            ...datalabels,
            display: (context) => {
              if (!this.showDataLabels) return false
              const value = context.dataset.data[context.dataIndex]
              return !(value === 0 || value === '0' || value === null || value === undefined)
            }
          }
        }
      }
    }
  }
}
</script>
